var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.01851 1.72461C4.54256 1.72461 2.53041 3.73676 2.53041 6.21268V8.37443C2.53041 8.83072 2.33593 9.52637 2.10404 9.91534L1.24383 11.344C0.712738 12.2267 1.07926 13.2066 2.05168 13.5357C5.27561 14.6129 8.7539 14.6129 11.9778 13.5357C12.8829 13.2365 13.2794 12.1669 12.7857 11.344L11.9255 9.91534C11.7011 9.52637 11.5066 8.83072 11.5066 8.37443V6.21268C11.5066 3.74424 9.48695 1.72461 7.01851 1.72461Z",
    stroke: "#426CFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.40046 1.9425C8.16858 1.87517 7.92921 1.82281 7.68237 1.79289C6.96427 1.70313 6.2761 1.75549 5.63281 1.9425C5.84974 1.38897 6.38831 1 7.01664 1C7.64497 1 8.18354 1.38897 8.40046 1.9425Z",
    stroke: "#426CFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.2615 13.8066C9.2615 15.0409 8.25168 16.0507 7.01746 16.0507C6.40409 16.0507 5.8356 15.7964 5.43169 15.3924C5.02776 14.9885 4.77344 14.42 4.77344 13.8066",
    stroke: "#426CFF",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_Icon.11b17406220133dea0b3cc4988010f97.svg";
export { ForwardRef as ReactComponent };